// src/Dashboard.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './Login';
import Navbar from './Navbar';
import Clients from './Clients';
import Buy from './Buy';
import Stock from './Stock';
import Transactions from './Transactions';
import Convert from './LangdiWeightPage';
import AddToPure from './AddToPure';
import AddToLangdiWeight from './AddToLangdiWeight';
import AddToCashAmount from './AddToCashAmount';
import SellPureWeight from './SellPureWeight';
import SellLangdiWeight from './SellLangdiWeight';
import SellCashAmount from './SellCashAmount';
import Speed from './Speed';
import SpeedThane from './SpeedThane';
import Advance from './Advance';
import Articles from './Articles';
import AddToArticle from './AddToArticle';
import SellArticle from './SellArticle';
import UserManagement from './UserManagement';
import ChangePassword from './ChangePassword';

// Protected route wrapper — checks auth + optional permission
const ProtectedRoute = ({ children, module: moduleName }) => {
  const { isAuthenticated, canView, isSuperAdmin } = useAuth();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (moduleName && !canView(moduleName) && !isSuperAdmin()) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">You don't have permission to access this page.</div>
      </div>
    );
  }
  return children;
};

const AppRoutes = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to="/buy" replace />} />
        <Route path="/clients" element={<ProtectedRoute module="clients"><Clients /></ProtectedRoute>} />
        <Route path="/buy" element={<ProtectedRoute module="buy"><Buy /></ProtectedRoute>} />
        <Route path="/stock" element={<ProtectedRoute module="stock"><Stock /></ProtectedRoute>} />
        <Route path="/transactions" element={<ProtectedRoute module="transactions"><Transactions /></ProtectedRoute>} />
        <Route path="/convert" element={<ProtectedRoute module="convert"><Convert /></ProtectedRoute>} />
        <Route path="/articles" element={<ProtectedRoute module="articles"><Articles /></ProtectedRoute>} />
        <Route path="/add-to-pure" element={<ProtectedRoute module="add"><AddToPure /></ProtectedRoute>} />
        <Route path="/add-to-langdi" element={<ProtectedRoute module="add"><AddToLangdiWeight /></ProtectedRoute>} />
        <Route path="/add-cash" element={<ProtectedRoute module="add"><AddToCashAmount /></ProtectedRoute>} />
        <Route path="/add-article" element={<ProtectedRoute module="add"><AddToArticle /></ProtectedRoute>} />
        <Route path="/sell-pure-weight" element={<ProtectedRoute module="sell"><SellPureWeight /></ProtectedRoute>} />
        <Route path="/sell-langdi-weight" element={<ProtectedRoute module="sell"><SellLangdiWeight /></ProtectedRoute>} />
        <Route path="/sell-cash-amount" element={<ProtectedRoute module="sell"><SellCashAmount /></ProtectedRoute>} />
        <Route path="/sell-article" element={<ProtectedRoute module="sell"><SellArticle /></ProtectedRoute>} />
        <Route path="/speed" element={<ProtectedRoute module="speed"><Speed /></ProtectedRoute>} />
        <Route path="/speed-thane" element={<ProtectedRoute module="speedThane"><SpeedThane /></ProtectedRoute>} />
        <Route path="/advance" element={<ProtectedRoute module="advance"><Advance /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
};

const Dashboard = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default Dashboard;
